import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase';
import BarChart from '../../Charts/BarChart';

function TransfersLeague({leagueId}) {

    const [labels, setLabels] = useState();
    const [data, setData] = useState();
    const [id, setId] = useState();
    const [league, setLeague] = useState();

    useEffect(() => {

        if (leagueId) {
            try {
                const leagueTransfersRef = firestore.collection("top-leagues");
                leagueTransfersRef.where("league_id", "==", leagueId).onSnapshot(({docs}) => {
                    const leagues = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    if (leagues) {
                        setLeague(leagues[0])
                    }
                });
            } catch (error) {
                
            }
        }

    }, [leagueId])

    useEffect(() => {

        if (league) {
            try {
                const leagueTransfersRef = firestore.collection("top-leagues").doc(league.id).collection("top_transfers");
                leagueTransfersRef.orderBy("spend_amount", "desc").limit(5).onSnapshot(({docs}) => {
                    const transfers = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    });
                    const labels = transfers.map(transfer => {
                        return transfer.club
                    })
                    const data = transfers.map(transfer => {
                        return transfer.spend_amount
                    })
                    console.log(data, "DATA")
                    console.log(transfers, "Transfers")
                    setLabels(labels);
                    setData(data);
                })
            } catch (error) {
                
            }
        }

    }, [league])

    return (
        <div className="bg-white p-2">
            {labels && data && (
                <BarChart data={data} labels={labels} description="€ spent in millions" />
            )}
        </div>
    )

}
export default TransfersLeague